import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

import { IconsModule } from '@prlw/libs/icons/icons.module';
import { MonitorPage } from './monitor.page';

const routes: Routes = [
  {
    matcher: (segments) => ({ consumed: segments }),
    component: MonitorPage,
  },
];

@NgModule({
  imports: [CommonModule, RouterModule.forChild(routes), IconsModule],
  declarations: [],
  exports: [RouterModule],
})
export class MonitorRoutingModule {}
